export const GameType = Object.freeze({
    SOLO: 'Solo',
    ROUNDROBIN: 'Round-Robin',
    TOURNAMENT: 'Tournament',
    CHALLENGE: 'Challenge'
  });